// extracted by mini-css-extract-plugin
export default {"answerLink":"Parser_answerLink__zLf1J"};